var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeta12360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0,
    id: "lorc-brain-gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff6cab",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7a21ef",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64.592 15.096 c -7.38 0 -13.148 5.558 -18.371 12.619 c -7.176 -9.137 -13.178 -12.619 -20.36 -12.619 C 11.219 15.096 0 34.152 0 54.322 c 0 12.621 6.106 20.582 16.334 20.582 c 7.361 0 12.655 -3.471 22.067 -19.922 c 0 0 3.923 -6.928 6.622 -11.701 c 0.946 1.527 1.942 3.173 2.988 4.936 l 4.413 7.424 c 8.597 14.386 13.387 19.262 22.067 19.262 C 84.455 74.904 90 66.834 90 53.95 C 90 32.832 78.528 15.096 64.592 15.096 z M 31.224 50.527 c -7.63 11.961 -10.27 14.642 -14.519 14.642 c -4.372 0 -6.971 -3.838 -6.971 -10.683 c 0 -14.642 7.301 -29.615 16.004 -29.615 c 4.713 0 8.651 2.722 14.684 11.358 C 34.694 45.016 31.224 50.527 31.224 50.527 z M 74.698 65.169 c -4.346 0 -6.423 -2.87 -14.675 -16.148 l -5.277 -8.801 c -1.428 -2.322 -2.8 -4.46 -4.117 -6.413 c 4.756 -7.34 8.679 -10.998 13.344 -10.998 c 9.693 0 17.447 14.271 17.447 31.801 C 81.421 61.292 79.232 65.169 74.698 65.169 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "url(#lorc-brain-gradient-1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta12360);
export default __webpack_public_path__ + "static/media/meta-12360.900e137cd945a4e6dc9bf642f231cb21.svg";
export { ForwardRef as ReactComponent };